import { render, staticRenderFns } from "./cordova.vue?vue&type=template&id=0652f816&scoped=true&"
import script from "./cordova.vue?vue&type=script&lang=js&"
export * from "./cordova.vue?vue&type=script&lang=js&"
import style0 from "./cordova.vue?vue&type=style&index=0&id=0652f816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652f816",
  null
  
)

export default component.exports